import _defineProperty from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _classCallCheck from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _toConsumableArray from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { EventEmitter } from 'betsy';
import isPlainObject from 'is-plain-obj';
import { IS_PROXY, ProxyStateTree, VALUE } from 'proxy-state-tree';
import { Devtools, safeValue, safeValues } from './Devtools';
import { EventType } from './internalTypes';
import { proxifyEffects } from './proxyfyEffects';
import { deepCopy, MockedEventEmitter, makeStringifySafeMutations, mergeState, IS_TEST, IS_OPERATOR, getFunctionName, getActionPaths, createActionsProxy, EXECUTION, processState } from './utils';
import { operatorStarted, operatorStopped, createContext, createNextPath, createMutationOperator, createOperator } from './operator';
export * from './types';
export { createOperator, createMutationOperator };
export var MODE_DEFAULT = Symbol('MODE_DEFAULT');
export var MODE_TEST = Symbol('MODE_TEST');
export var MODE_SSR = Symbol('MODE_SSR');
export var json = function json(obj) {
  return deepCopy(obj && obj[IS_PROXY] ? obj[VALUE] : obj);
};
export var rehydrate = function rehydrate(state, mutations) {
  mutations.forEach(function (mutation) {
    var pathArray = mutation.path.split('.');
    var key = pathArray.pop();
    var target = pathArray.reduce(function (aggr, key) {
      return aggr[key];
    }, state);

    if (mutation.method === 'set') {
      target[key] = mutation.args[0];
    } else if (mutation.method === 'unset') {
      delete target[key];
    } else {
      var _target$key;

      (_target$key = target[key])[mutation.method].apply(_target$key, _toConsumableArray(mutation.args));
    }
  });
};
export function createOvermindSSR(config) {
  var ssr = new Overmind(config, {
    devtools: false
  }, {
    mode: MODE_SSR
  });
  var mutationTree = ssr.proxyStateTree.getMutationTree();
  ssr.state = mutationTree.state;

  ssr.hydrate = function () {
    return mutationTree.flush().mutations;
  };

  return ssr;
}
export function createOvermindMock(config, mockedEffects) {
  var mock = new Overmind(Object.assign({}, config, {
    state: deepCopy(config.state)
  }), {
    devtools: false
  }, {
    mode: MODE_TEST,
    options: {
      effectsCallback: function effectsCallback(effect) {
        var mockedEffect = (effect.name ? effect.name.split('.') : []).reduce(function (aggr, key) {
          return aggr ? aggr[key] : aggr;
        }, mockedEffects);

        if (!mockedEffect || mockedEffect && !mockedEffect[effect.method]) {
          throw new Error("The effect \"".concat(effect.name, "\" with metod ").concat(effect.method, " has not been mocked"));
        }

        return mockedEffect[effect.method].apply(mockedEffect, _toConsumableArray(effect.args));
      }
    }
  });
  var action = mock.createAction('onInitialize', config.onInitialize);

  mock.onInitialize = function () {
    return action(mock);
  };

  mock.mutations = [];
  return mock;
}
export function createOvermind(config, options) {
  return new Overmind(config, options, {
    mode: MODE_DEFAULT
  });
}
var hotReloadingCache = {}; // We do not use IConfig<Config> directly to type the class in order to avoid
// the 'import(...)' function to be used in exported types.

export var Overmind =
/*#__PURE__*/
function () {
  function Overmind(configuration) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      mode: MODE_DEFAULT
    };

    _classCallCheck(this, Overmind);

    this.actionReferences = [];
    this.nextExecutionId = 0;
    this.derivedReferences = [];

    this.addMutationListener = function (cb) {
      return _this.proxyStateTree.onMutation(cb);
    };

    this.addFlushListener = function (cb) {
      return _this.proxyStateTree.onFlush(cb);
    };

    var name = options.name || 'OvermindApp';

    if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development') && mode.mode === MODE_DEFAULT && options.hotReloading !== false && !(process && process.title && process.title.includes('node'))) {
      if (hotReloadingCache[name]) {
        return hotReloadingCache[name].reconfigure(configuration);
      } else {
        hotReloadingCache[name] = this;
      }
    }
    /*
      Set up an eventHub to trigger information from derived, computed and reactions
    */


    var eventHub = mode.mode === MODE_SSR ? new MockedEventEmitter() : new EventEmitter();
    /*
      Create the proxy state tree instance with the state and a wrapper to expose
      the eventHub
    */

    var proxyStateTree = this.createProxyStateTree(configuration, eventHub, mode.mode === MODE_SSR ? false : process.env.NODE_ENV === 'development');
    this.originalConfiguration = configuration;
    this.state = proxyStateTree.state;
    this.effects = configuration.effects || {};
    this.proxyStateTree = proxyStateTree;
    this.eventHub = eventHub;
    this.mode = mode;

    if (mode.mode === MODE_SSR) {
      return;
    }

    if (process.env.NODE_ENV === 'development' && mode.mode === MODE_DEFAULT && typeof window !== 'undefined') {
      var warning = 'OVERMIND: You are running in DEVELOPMENT mode.';

      if (options.logProxies !== true) {
        var originalConsoleLog = console.log;

        console.log = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return originalConsoleLog.apply(console, args.map(function (arg) {
            return arg && arg[IS_PROXY] ? arg[VALUE] : arg;
          }));
        };

        warning += '\n\n - To improve debugging experience "console.log" will NOT log proxies from Overmind, but the actual value. Please see docs to turn off this behaviour';
      }

      if (options.devtools || typeof location !== 'undefined' && location.hostname === 'localhost' && options.devtools !== false) {
        var host = options.devtools === true ? 'localhost:3031' : options.devtools;

        var _name = options.name ? options.name : typeof document === 'undefined' ? 'NoName' : document.title || 'NoName';

        this.initializeDevtools(host, _name, eventHub, proxyStateTree.sourceState, configuration.actions);
      } else {
        warning += '\n\n - You are not running on localhost. You will have to manually define the devtools option to connect';
      }

      if (!IS_TEST) {
        console.warn(warning);
      }
    }

    if (process.env.NODE_ENV === 'production' && mode.mode === MODE_DEFAULT) {
      eventHub.on(EventType.OPERATOR_ASYNC, function () {
        proxyStateTree.getMutationTree().flush(true);
      });
      eventHub.on(EventType.ACTION_END, function (execution) {
        if (!execution.parentExecution || !execution.parentExecution.isRunning) proxyStateTree.getMutationTree().flush();
      });
      var nextTick;

      var flushTree = function flushTree() {
        proxyStateTree.getMutationTree().flush(true);
      };

      this.proxyStateTree.onMutation(function () {
        nextTick && clearTimeout(nextTick);
        nextTick = setTimeout(flushTree, 0);
      });
    } else if (mode.mode === MODE_DEFAULT) {
      eventHub.on(EventType.OPERATOR_ASYNC, function (execution) {
        var flushData = execution.flush(true);

        if (_this.devtools && flushData.mutations.length) {
          _this.devtools.send({
            type: 'flush',
            data: Object.assign({}, execution, flushData)
          });
        }
      });
      eventHub.on(EventType.ACTION_END, function (execution) {
        if (!execution.parentExecution || !execution.parentExecution.isRunning) {
          var flushData = execution.flush();

          if (_this.devtools && flushData.mutations.length) {
            _this.devtools.send({
              type: 'flush',
              data: Object.assign({}, execution, flushData)
            });
          }
        }
      });
    }
    /*
      Expose the created actions
    */


    this.actions = this.getActions(configuration.actions);

    if (mode.mode === MODE_DEFAULT && configuration.onInitialize) {
      var onInitialize = this.createAction('onInitialize', configuration.onInitialize);
      this.initialized = Promise.resolve(onInitialize(this));
    } else {
      this.initialized = Promise.resolve(null);
    }
  }

  _createClass(Overmind, [{
    key: "createProxyStateTree",
    value: function createProxyStateTree(configuration, eventHub, devmode) {
      var _this2 = this;

      var proxyStateTree = new ProxyStateTree(this.getState(configuration), {
        devmode: devmode,
        dynamicWrapper: function dynamicWrapper(_, path, func) {
          return func(eventHub, proxyStateTree, path);
        },
        onGetter: devmode ? function (path, value) {
          _this2.eventHub.emitAsync(EventType.GETTER, {
            path: path,
            value: safeValue(value)
          });
        } : undefined
      });
      return proxyStateTree;
    }
  }, {
    key: "createExecution",
    value: function createExecution(name, action, parentExecution) {
      var _this3 = this,
          _execution;

      if (process.env.NODE_ENV === 'production') {
        var _ref;

        return _ref = {}, _defineProperty(_ref, EXECUTION, true), _defineProperty(_ref, "parentExecution", parentExecution), _defineProperty(_ref, "getMutationTree", function getMutationTree() {
          return _this3.proxyStateTree.getMutationTree();
        }), _defineProperty(_ref, "emit", this.eventHub.emit.bind(this.eventHub)), _ref;
      }

      var mutationTrees = [];
      var execution = (_execution = {}, _defineProperty(_execution, EXECUTION, true), _defineProperty(_execution, "actionId", this.actionReferences.indexOf(action)), _defineProperty(_execution, "executionId", this.nextExecutionId++), _defineProperty(_execution, "actionName", name), _defineProperty(_execution, "operatorId", 0), _defineProperty(_execution, "isRunning", true), _defineProperty(_execution, "parentExecution", parentExecution), _defineProperty(_execution, "path", []), _defineProperty(_execution, "emit", this.eventHub.emit.bind(this.eventHub)), _defineProperty(_execution, "send", this.devtools ? this.devtools.send.bind(this.devtools) : function () {}), _defineProperty(_execution, "trackEffects", this.trackEffects.bind(this, this.effects)), _defineProperty(_execution, "getNextOperatorId", function () {
        var currentOperatorId = 0;
        return function () {
          return ++currentOperatorId;
        };
      }()), _defineProperty(_execution, "flush", parentExecution ? parentExecution.flush : function (isAsync) {
        return _this3.proxyStateTree.flush(mutationTrees, isAsync);
      }), _defineProperty(_execution, "getMutationTree", parentExecution ? parentExecution.getMutationTree : function () {
        var mutationTree = _this3.proxyStateTree.getMutationTree();

        mutationTrees.push(mutationTree);

        if (_this3.mode.mode === MODE_TEST) {
          mutationTree.onMutation(function (mutation) {
            _this3.addExecutionMutation(mutation);
          });
        }

        return mutationTree;
      }), _defineProperty(_execution, "scopeValue", function scopeValue(value, tree) {
        return _this3.scopeValue(value, tree);
      }), _execution);
      return execution;
    }
  }, {
    key: "createContext",
    value: function createContext(execution, tree) {
      return {
        state: tree.state,
        actions: createActionsProxy(this.actions, function (action) {
          return function (value) {
            return action(value, execution.isRunning ? execution : null);
          };
        }),
        execution: execution,
        proxyStateTree: this.proxyStateTree,
        effects: this.trackEffects(this.effects, execution)
      };
    }
  }, {
    key: "scopeValue",
    value: function scopeValue(value, tree) {
      var _this4 = this;

      if (!value) {
        return value;
      }

      if (value[IS_PROXY]) {
        return this.proxyStateTree.rescope(value, tree);
      } else if (isPlainObject(value)) {
        return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(value).map(function (key) {
          return _defineProperty({}, key, _this4.proxyStateTree.rescope(value[key], tree));
        }))));
      } else {
        return value;
      }
    }
  }, {
    key: "addExecutionMutation",
    value: function addExecutionMutation(mutation) {
      ;
      this.mutations.push(mutation);
    }
  }, {
    key: "createAction",
    value: function createAction(name, action) {
      var _this5 = this;

      this.actionReferences.push(action);

      var actionFunc = function actionFunc(value, boundExecution) {
        // Developer might unintentionally pass more arguments, so have to ensure
        // that it is an actual execution
        boundExecution = boundExecution && boundExecution[EXECUTION] ? boundExecution : undefined;

        if (process.env.NODE_ENV === 'production' || action[IS_OPERATOR]) {
          var execution = _this5.createExecution(name, action, boundExecution);

          _this5.eventHub.emit(EventType.ACTION_START, Object.assign({}, execution, {
            value: safeValue(value)
          }));

          if (action[IS_OPERATOR]) {
            return new Promise(function (resolve, reject) {
              action(null, {
                value: value,
                state: _this5.proxyStateTree.state,
                actions: _this5.actions,
                execution: execution,
                effects: _this5.trackEffects(_this5.effects, execution)
              }, function (err, finalContext) {
                execution.isRunning = false;
                finalContext && _this5.eventHub.emit(EventType.ACTION_END, Object.assign({}, finalContext.execution, {
                  operatorId: finalContext.execution.operatorId - 1
                }));
                if (err) reject(err);else {
                  resolve(_this5.mode.mode === MODE_TEST ? finalContext.execution : undefined);
                }
              });
            });
          } else {
            var returnValue = action(_this5.createContext(execution, execution.getMutationTree()), value);

            _this5.eventHub.emit(EventType.ACTION_END, execution);

            return returnValue;
          }
        } else {
          var _execution2 = Object.assign({}, _this5.createExecution(name, action, boundExecution), {
            operatorId: 0,
            type: 'action'
          });

          _this5.eventHub.emit(EventType.ACTION_START, Object.assign({}, _execution2, {
            value: safeValue(value)
          }));

          _this5.eventHub.emit(EventType.OPERATOR_START, _execution2);

          var mutationTree = _execution2.getMutationTree();

          mutationTree.onMutation(function (mutation) {
            _this5.eventHub.emit(EventType.MUTATIONS, Object.assign({}, _execution2, {
              mutations: makeStringifySafeMutations([mutation])
            }));
          });

          var scopedValue = _this5.scopeValue(value, mutationTree);

          var context = _this5.createContext(_execution2, mutationTree);

          try {
            var result = action(context, scopedValue);

            if (result instanceof Promise) {
              _this5.eventHub.emit(EventType.OPERATOR_ASYNC, _execution2);

              result.then(function () {
                _execution2.isRunning = false;
                mutationTree.dispose();

                _this5.eventHub.emit(EventType.OPERATOR_END, Object.assign({}, _execution2, {
                  isAsync: true,
                  result: undefined
                }));

                _this5.eventHub.emit(EventType.ACTION_END, _execution2);
              });
            } else {
              _execution2.isRunning = false;
              mutationTree.dispose();

              _this5.eventHub.emit(EventType.OPERATOR_END, Object.assign({}, _execution2, {
                isAsync: false,
                result: undefined
              }));

              _this5.eventHub.emit(EventType.ACTION_END, _execution2);
            }

            var pendingFlush;
            mutationTree.onMutation(function (mutation) {
              if (pendingFlush) {
                clearTimeout(pendingFlush);
              }

              if (_this5.mode.mode === MODE_TEST) {
                _this5.addExecutionMutation(mutation);
              }

              pendingFlush = setTimeout(function () {
                pendingFlush = null;

                var flushData = _execution2.flush(true);

                if (_this5.devtools && flushData.mutations.length) {
                  _this5.devtools.send({
                    type: 'flush',
                    data: Object.assign({}, _execution2, flushData, {
                      mutations: makeStringifySafeMutations(flushData.mutations)
                    })
                  });
                }
              });
            });
            return result;
          } catch (err) {
            _this5.eventHub.emit(EventType.OPERATOR_END, Object.assign({}, _execution2, {
              isAsync: false,
              result: undefined,
              error: err.message
            }));

            _this5.eventHub.emit(EventType.ACTION_END, _execution2);

            throw err;
          }
        }
      };

      return actionFunc;
    }
  }, {
    key: "trackEffects",
    value: function trackEffects() {
      var _this6 = this;

      var effects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var execution = arguments.length > 1 ? arguments[1] : undefined;

      if (process.env.NODE_ENV === 'production') {
        return effects;
      }

      return proxifyEffects(this.effects, function (effect) {
        var result;

        try {
          if (_this6.mode.mode === MODE_TEST) {
            var mode = _this6.mode;
            result = mode.options.effectsCallback(effect);
          } else {
            _this6.eventHub.emit(EventType.EFFECT, Object.assign({}, execution, effect, {
              args: safeValues(effect.args),
              isPending: true,
              error: false
            }));

            result = effect.func.apply(_this6, effect.args);
          }
        } catch (error) {
          // eslint-disable-next-line standard/no-callback-literal
          _this6.eventHub.emit(EventType.EFFECT, Object.assign({}, execution, effect, {
            args: safeValues(effect.args),
            isPending: false,
            error: error.message
          }));

          throw error;
        }

        if (result instanceof Promise) {
          // eslint-disable-next-line standard/no-callback-literal
          _this6.eventHub.emit(EventType.EFFECT, Object.assign({}, execution, effect, {
            args: safeValues(effect.args),
            isPending: true,
            error: false
          }));

          return result.then(function (promisedResult) {
            // eslint-disable-next-line standard/no-callback-literal
            _this6.eventHub.emit(EventType.EFFECT, Object.assign({}, execution, effect, {
              args: safeValues(effect.args),
              result: safeValue(promisedResult),
              isPending: false,
              error: false
            }));

            return promisedResult;
          }).catch(function (error) {
            _this6.eventHub.emit(EventType.EFFECT, Object.assign({}, execution, effect, {
              args: safeValues(effect.args),
              isPending: false,
              error: error && error.message
            }));

            throw error;
          });
        } // eslint-disable-next-line standard/no-callback-literal


        _this6.eventHub.emit(EventType.EFFECT, Object.assign({}, execution, effect, {
          args: safeValues(effect.args),
          result: safeValue(result),
          isPending: false,
          error: false
        }));

        return result;
      });
    }
  }, {
    key: "initializeDevtools",
    value: function initializeDevtools(host, name, eventHub, initialState, actions) {
      var _this7 = this;

      if (process.env.NODE_ENV === 'production') return;
      var devtools = new Devtools(name);
      devtools.connect(host, function (message) {
        if (message.appName !== name) {
          return;
        }

        switch (message.type) {
          case 'refresh':
            location.reload(true);
            break;

          case 'executeAction':
            var _action = message.data.name.split('.').reduce(function (aggr, key) {
              return aggr[key];
            }, _this7.actions);

            message.data.payload ? _action(JSON.parse(message.data.payload)) : _action();
            break;

          case 'mutation':
            var tree = _this7.proxyStateTree.getMutationTree();

            var path = message.data.path.slice();
            var value = JSON.parse("{ \"value\": ".concat(message.data.value, " }")).value;
            var key = path.pop();
            var state = path.reduce(function (aggr, key) {
              return aggr[key];
            }, tree.state);
            state[key] = value;
            tree.flush(true);
            tree.dispose();

            _this7.devtools.send({
              type: 'state',
              data: {
                path: message.data.path,
                value: value
              }
            });

        }
      });

      var _loop = function _loop(type) {
        eventHub.on(EventType[type], function (eventType) {
          return function (data) {
            devtools.send({
              type: EventType[type],
              data: data
            }); // Access the derived async, which will trigger calculation and devtools

            if (eventType === EventType.DERIVED_DIRTY) {
              data.derivedPath.split('.').reduce(function (aggr, key) {
                return aggr[key];
              }, _this7.proxyStateTree.state);
            }
          };
        }(EventType[type]));
      };

      for (var type in EventType) {
        _loop(type);
      }

      devtools.send({
        type: 'init',
        data: {
          state: this.proxyStateTree.state,
          actions: getActionPaths(actions)
        }
      });
      this.devtools = devtools;
    }
  }, {
    key: "getState",
    value: function getState(configuration) {
      var state = {};

      if (configuration.state) {
        state = processState(configuration.state, process.env.NODE_ENV === 'development' ? this.derivedReferences : undefined);
      }

      return state;
    }
  }, {
    key: "getActions",
    value: function getActions() {
      var _this8 = this;

      var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return Object.keys(actions).reduce(function (aggr, name) {
        if (typeof actions[name] === 'function') {
          var _action2 = _this8.createAction(path.concat(name).join('.'), actions[name]);

          _action2.displayName = path.concat(name).join('.');
          return Object.assign(aggr, _defineProperty({}, name, _action2));
        }

        return Object.assign(aggr, _defineProperty({}, name, _this8.getActions(actions[name], path.concat(name))));
      }, {});
    }
  }, {
    key: "getTrackStateTree",
    value: function getTrackStateTree() {
      return this.proxyStateTree.getTrackStateTree();
    }
  }, {
    key: "getMutationTree",
    value: function getMutationTree() {
      return this.proxyStateTree.getMutationTree();
    }
  }, {
    key: "reconfigure",
    value: function reconfigure(configuration) {
      this.derivedReferences.forEach(function (derived) {
        derived.dispose();
      });
      this.derivedReferences.length = 0;
      var mergedConfiguration = Object.assign({}, configuration, {
        state: mergeState(this.originalConfiguration.state, this.state, configuration.state)
      });
      var proxyStateTree = this.proxyStateTree;
      this.originalConfiguration.state = configuration.state;
      this.proxyStateTree.sourceState = this.getState(mergedConfiguration);
      proxyStateTree.createTrackStateProxifier();
      this.state = this.proxyStateTree.state;
      this.actions = this.getActions(mergedConfiguration.actions);
      this.effects = mergedConfiguration.effects || {};
      this.proxyStateTree.forceFlush();

      if (this.devtools) {
        this.devtools.send({
          type: 're_init',
          data: {
            state: proxyStateTree.state,
            actions: getActionPaths(configuration.actions)
          }
        });
      }

      return this;
    }
  }]);

  return Overmind;
}();
export function pipe() {
  for (var _len2 = arguments.length, operators = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    operators[_key2] = arguments[_key2];
  }

  var instance = function instance(err, context, next) {
    var _final = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : next;

    if (err) next(err, context);else {
      var operatorIndex = 0;

      var _run = function _run(operatorErr, operatorContext) {
        var operator = operators[operatorIndex++];

        try {
          ;
          (operator || next)(operatorErr, operatorContext, _run, _final);
        } catch (operatorError) {
          ;
          (operator || next)(operatorError, operatorContext, _run, _final);
        }
      };

      _run(null, context);
    }
  };

  instance[IS_OPERATOR] = true;
  return instance;
}
/*
  OPERATORS
*/

export function forEach(forEachItemOperator) {
  var instance = function instance(err, context, next) {
    if (err) next(err, context);else {
      var array = context.value;
      var evaluatingCount = array.length;
      var lastContext;
      var hasErrored = false;

      var evaluate = function evaluate(err) {
        if (hasErrored) {
          return;
        }

        if (err) {
          hasErrored = true;
          return next(err);
        }

        evaluatingCount--;

        if (!evaluatingCount) {
          operatorStopped(context, context.value);
          next(null, createContext(lastContext, context.value, lastContext.execution.path && lastContext.execution.path.slice(0, lastContext.execution.path.length - 1)));
        }
      };

      operatorStarted('forEach', '', context);

      if (array.length) {
        array.forEach(function (value, index) {
          lastContext = createContext(lastContext || context, value, context.execution.path && context.execution.path.concat(String(index)));
          var nextWithPath = createNextPath(evaluate); // @ts-ignore

          forEachItemOperator(null, lastContext, nextWithPath);
        });
      } else {
        operatorStopped(context, context.value);
        next(null, createContext(context, context.value));
      }
    }
  };

  instance[IS_OPERATOR] = true;
  return instance;
}
export function parallel() {
  for (var _len3 = arguments.length, operators = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    operators[_key3] = arguments[_key3];
  }

  var instance = function instance(err, context, next) {
    if (err) next(err, context);else {
      var evaluatingCount = operators.length;
      var lastContext;
      var hasErrored = false;

      var evaluate = function evaluate(err) {
        if (hasErrored) {
          return;
        }

        if (err) {
          hasErrored = true;
          return next(err, lastContext);
        }

        evaluatingCount--;

        if (!evaluatingCount) {
          operatorStopped(context, context.value);
          next(null, createContext(lastContext, context.value, lastContext.execution.path && lastContext.execution.path.slice(0, lastContext.execution.path.length - 1)));
        }
      };

      operatorStarted('parallel', '', context);
      operators.forEach(function (operator, index) {
        lastContext = createContext(lastContext || context, context.value, context.execution.path && context.execution.path.concat(String(index)));
        var nextWithPath = createNextPath(evaluate); // @ts-ignore

        operator(null, lastContext, nextWithPath);
      });
    }
  };

  instance[IS_OPERATOR] = true;
  return instance;
}
export function map(operation) {
  return createOperator('map', getFunctionName(operation), function (err, context, value, next) {
    if (err) next(err, value);else next(null, operation(context, value));
  });
}
export function noop() {
  return createOperator('noop', '', function (err, context, value, next) {
    if (err) next(err, value);else next(null, value);
  });
}
export function filter(operation) {
  return createOperator('filter', getFunctionName(operation), function (err, context, value, next, _final2) {
    if (err) next(err, value);else if (operation(context, value)) next(null, value);else _final2(null, value);
  });
}
var hasShownActionDeprecation = false;
export function action(operation) {
  if (!hasShownActionDeprecation) {
    console.warn("DEPRECATION - The action operator is deprecated in favor of \"mutate\". The reason is to avoid confusion between actions and operators. Check out action \"".concat(getFunctionName(operation), "\""));
    hasShownActionDeprecation = true;
  }

  return createMutationOperator('action', getFunctionName(operation), function (err, context, value, next) {
    if (err) next(err, value);else {
      var result = operation(context, value);

      if (result instanceof Promise) {
        next(null, result.then(function () {
          return value;
        }));
      } else {
        next(null, value);
      }
    }
  });
}
export function mutate(operation) {
  return createMutationOperator('mutate', getFunctionName(operation), function (err, context, value, next) {
    if (err) next(err, value);else {
      var result = operation(context, value);

      if (result instanceof Promise) {
        next(null, result.then(function () {
          return value;
        }));
      } else {
        next(null, value);
      }
    }
  });
}
export function run(operation) {
  return createOperator('run', getFunctionName(operation), function (err, context, value, next) {
    if (err) next(err, value);else {
      var result = operation(context, value);

      if (result instanceof Promise) {
        next(null, result.then(function () {
          return value;
        }));
      } else {
        next(null, value);
      }
    }
  });
}
export function catchError(operation) {
  return createMutationOperator('catchError', getFunctionName(operation), function (err, context, value, next) {
    if (err) next(null, operation(context, err));else next(null, value, {
      isSkipped: true
    });
  });
}
export function tryCatch(paths) {
  var instance = function instance(err, context, next) {
    if (err) next(err, context);else {
      var evaluateCatch = function evaluateCatch(err, catchContext) {
        operatorStopped(context, context.value);
        next(err, createContext(catchContext, context.value));
      };

      var evaluateTry = function evaluateTry(err, tryContext) {
        if (err) {
          var _newContext = createContext(tryContext, err, context.execution.path && context.execution.path.concat('catch'));

          var _nextWithPath = createNextPath(evaluateCatch); // @ts-ignore


          paths.catch(null, _newContext, _nextWithPath);
        } else {
          operatorStopped(context, context.value);
          next(null, createContext(tryContext, context.value));
        }
      };

      operatorStarted('tryCatch', '', context);
      var newContext = createContext(context, context.value, context.execution.path && context.execution.path.concat('try'));
      var nextWithPath = createNextPath(evaluateTry); // @ts-ignore

      paths.try(null, newContext, nextWithPath);
    }
  };

  instance[IS_OPERATOR] = true;
  return instance;
}
export function fork(operation, paths) {
  return createOperator('fork', getFunctionName(operation), function (err, context, value, next) {
    if (err) next(err, value);else {
      var path = operation(context, value);
      next(null, value, {
        path: {
          name: String(path),
          operator: paths[path]
        }
      });
    }
  });
}
export function when(operation, paths) {
  return createOperator('when', getFunctionName(operation), function (err, context, value, next) {
    if (err) next(err, value);else if (operation(context, value)) next(null, value, {
      path: {
        name: 'true',
        operator: paths.true
      }
    });else next(null, value, {
      path: {
        name: 'false',
        operator: paths.false
      }
    });
  });
}
export function wait(ms) {
  return createOperator('wait', String(ms), function (err, context, value, next) {
    if (err) next(err, value);else setTimeout(function () {
      return next(null, value);
    }, ms);
  });
}
export function debounce(ms) {
  var timeout;
  var previousFinal;
  return createOperator('debounce', String(ms), function (err, context, value, next, _final3) {
    if (err) next(err, value);else {
      if (timeout) {
        clearTimeout(timeout);
        previousFinal(null, value);
      }

      previousFinal = _final3;
      timeout = setTimeout(function () {
        timeout = null;
        next(null, value);
      }, ms);
    }
  });
}